"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferFilter = void 0;
// NOTE: ラップしてるだけなのでテストは書いてない
const bufferFilter = (availablePeriods, buffer) => {
    return availablePeriods.narrowDownMinutes(buffer);
};
exports.bufferFilter = bufferFilter;
//# sourceMappingURL=bufferFilter.js.map